import { OnInit, Component, ViewChild, Output, EventEmitter, Input, OnChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "src/app/alert-panel/alert.service";
import { ToastrService } from "ngx-toastr";
import { Claims } from "src/app/_models/common/claims";
import { environment } from "src/environments/environment";
import { NgOption } from "@ng-select/ng-select";
import { ApiRequest, GradeStatusEnum, IApiresponse, LogObjectActionTemplateEnum } from "src/app/_models";
import { BaseComponent } from "src/app/shared/base/base-component";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { DynamicFormComponent } from "src/app/shared/forms/dynamic-form/dynamic-form.component";
import { DynamicFormService } from "src/app/shared/forms/dynamic-form/dynamic-form.service";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { GetField } from "src/app/shared/forms/form-functions/form-functions";
import { IErrorInfo } from "src/app/_models/common/error-info";
import { LoggingPanelModel } from "src/app/_models/common/LoggingPanelModel";
import { LoggingPanelService } from "src/app/_services/logging-panel/logging-panel.service";
import { AddGradePanelInputModel,AddGradePanelOutputModel,GradeFormModel,IRequestGrade,RequestGrade,
    IResponseGrade,IRequestGradeBulkDeactivate,RequestGradeBulkDeactivate} from "src/app/_models/grade/grade";
import {  GradeService } from "src/app/_services";

@Component({
    selector: "add-grade-panel",
    templateUrl: "./add-grade-panel.component.html",
    standalone: false
})

export class AddGradePanelComponent extends BaseComponent implements OnInit {
    @ViewChild(DynamicFormComponent) gradeForm: DynamicFormComponent;

    @Input("inputModel")
    @Input() inputModel: AddGradePanelInputModel;
    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() submitEvent = new EventEmitter<AddGradePanelOutputModel>();

    currentUserSubscription: Subscription;
    userActionEventSubscription: Subscription;
    claimsSubscription: Subscription;
    claims: Claims;

    gradeFormModel: GradeFormModel;
    gradeFormFields: FormlyFieldConfig[] = [];

    panelHeading: string;
    disableSaveButton: boolean = false;
    gradeDetails: IResponseGrade;

    showDeactivateConfirmationAlert: boolean = false;
    deactivateConfirmationAlertModel: AlertPanelModel;

    constructor(
        private router: Router,
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private alertService: AlertService,
        private toastr: ToastrService,
        private dynamicFormService: DynamicFormService,
        private loggingPanelService: LoggingPanelService,
        private gradeService: GradeService,

    ) {
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
        this.fnObserveUnsavedChangesAlerts();
    }

    ngOnInit(): void {
        if (this.inputModel) {

            this.fnSetPanelHeading();

            if (!this.inputModel.isEditMode && !this.inputModel.isCopy) {
                this.fnInitializeForm();
            }       
            this.fnGetGradeDetails();
        }
    }

    canDeactivate(): boolean {
        return !this.gradeForm.form.dirty;
    }

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.closePanelEvent.emit(true);
        }
        else {
            this.alertService.onFormClosed();
        }
    }

    fnObserveUnsavedChangesAlerts() {
        var currentContext = this;
        this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
            if (action) {
                this.closePanelEvent.emit(true);
            }
        });
    }

    fnSetPanelHeading() {
        if (this.inputModel) {
            this.panelHeading = this.inputModel.isEditMode
                ? this.translate.instant('grade_edit')
                : (this.inputModel.isCopy ? this.translate.instant('grade_copy') : this.translate.instant('grade_new'))
        }
    }

    fnInitializeForm() {

        if (!this.inputModel.isEditMode && !this.inputModel.isCopy) {
            this.fnGenerateGradeFormModel();
        }

        let fields: FormlyFieldConfig[] = [];

        if (this.inputModel.isEditMode) {

            fields.push({
                fieldGroup: [
                    {
                        key: 'gradeToggle',
                        type: 'formly-toggle-input',
                        templateOptions: {
                            labelActive: this.translate.instant("label_activate"),
                            labelDeactive: this.translate.instant("label_deactivate"),
                            change: (field, $event) => {

                                this.gradeFormModel.gradeStatus = !this.gradeFormModel.gradeToggle
                                    ? GradeStatusEnum.Active
                                    : GradeStatusEnum.Inactive
                            }
                        }
                    }
                ]
            });
        }

        fields.push({
            fieldGroupClassName: 'block row mt-2',
            fieldGroup: [
                {
                    key: 'gradeName',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-0',
                    templateOptions: {
                      label: this.translate.instant('grade_name'),
                      placeholder: '',
                      required: true,
                      maxLength: 50,
                      maxLengthCount: true
                    }
                  },
                  {
                    key: 'gradeDescription',
                    type: 'text-input',
                    className: 'col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-right-0',
                    templateOptions: {
                      label: this.translate.instant('grade_description'),
                      placeholder: '',
                      required: true,
                      maxLength: 100,
                      maxLengthCount: true
                    }
                  }
            ]
        });

        this.gradeFormFields = fields;
    }

    fnGenerateGradeFormModel() {
        this.gradeFormModel = new GradeFormModel();
        this.gradeFormModel.gradeToggle = true;
        this.gradeFormModel.gradeId = 0;
        this.gradeFormModel.gradeName = '';
        this.gradeFormModel.gradeDescription = '';
       
        this.gradeFormModel.gradeStatus = GradeStatusEnum.Active;

        //mark form as pristine
        this.fnMarkFormAsPristine();
    }

    fnMarkFormAsPristine() {
        if (this.gradeForm && this.gradeForm.form) {
            this.gradeForm.form.markAsPristine();
        }
    }

    fnMarkFormAsDirty() {
        if (this.gradeForm && this.gradeForm.form) {
            this.gradeForm.form.markAsDirty();
        }
    }

    fnSubmitGrade() {
        this.dynamicFormService.onFormSubmitted(true);
        this.disableSaveButton = true;

        if (this.gradeForm.form.invalid) {
            this.disableSaveButton = false;
            return;
        }

        if (!this.inputModel.isEditMode) {
            this.fnAddGrade();
        } else {

            if (this.gradeDetails.gradeStatus == GradeStatusEnum.Active && this.gradeFormModel.gradeToggle == false) {
                this.fnShowDeactivateConfirmationAlert();
            } else {
                this.fnUpdateGrade();
            }
        }
    }

    fnGetGradeDetails() {
        if (!this.inputModel.isEditMode && !this.inputModel.isCopy) {
            return;
        }
        this.gradeService.GetGradeDetailsById(this.inputModel.gradeId)
            .subscribe((response: IApiresponse<IResponseGrade>) => {

                if (response.responseInfo != null) {

                    this.gradeDetails = response.responseInfo;

                    this.gradeFormModel = new GradeFormModel();

                    if(this.inputModel.isCopy){

                        this.gradeFormModel.gradeToggle = this.gradeDetails.gradeStatus == GradeStatusEnum.Active ? true : false;
                        this.gradeFormModel.gradeId = 0;
                        this.gradeFormModel.gradeName = `${this.translate.instant("copy_of")} ${this.gradeDetails.gradeName}`;
                        this.gradeFormModel.gradeDescription = `${this.translate.instant("copy_of")} ${this.gradeDetails.gradeDescription}`;
                        this.gradeFormModel.gradeStatus = this.gradeDetails.gradeStatus;    

                    }else{

                        this.gradeFormModel.gradeToggle = this.gradeDetails.gradeStatus == GradeStatusEnum.Active ? true : false;
                        this.gradeFormModel.gradeId = this.gradeDetails.gradeId;
                        this.gradeFormModel.gradeName = this.gradeDetails.gradeName;
                        this.gradeFormModel.gradeDescription = this.gradeDetails.gradeDescription;
                        this.gradeFormModel.gradeStatus = this.gradeDetails.gradeStatus;
                        this.gradeFormModel.isDefault = this.gradeDetails.isDefault;
                        this.gradeFormModel.isAnyEmployeeAssigned = this.gradeDetails.isAnyEmployeeAssigned;
                    }                 
                }
                this.fnInitializeForm();
            });
    }

    fnAddGrade() {

        let request = new ApiRequest<IRequestGrade>("CreateGrade", environment.applicationVersion, environment.requestId);

        let grade = new RequestGrade(
            this.claims.OrgId,
            this.gradeFormModel.gradeName,
            this.gradeFormModel.gradeDescription,
            this.gradeFormModel.gradeStatus,
            false,
            this.claims.UserId,
            this.claims.FinanceManager
        );

        request.requestInfo = grade;
        localStorage.setItem("gradeUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

        this.gradeService.CreateGrade(request)
            .subscribe((response: IApiresponse<any>) => {
                if (response && response.errorInfo && response.errorInfo.length > 0) {
                    let lstErrInfo = response.errorInfo;
                    this.fnShowServerErrors(lstErrInfo);
                }
                else {
                    this.toastr.success(this.translate.instant("success"));
                    this.fnEmitSubmitEvent();
                }
                this.disableSaveButton = false;
            });
    }

    fnUpdateGrade() {

        let request = new ApiRequest<IRequestGrade>("CreateGrade", environment.applicationVersion, environment.requestId);

        let grade = new RequestGrade(
            this.claims.OrgId,
            this.gradeFormModel.gradeName,
            this.gradeFormModel.gradeDescription,
            this.gradeFormModel.gradeStatus,
            this.gradeDetails.isDefault,
            this.claims.UserId,
            this.claims.FinanceManager
        );

        grade.gradeId = this.gradeDetails.gradeId;
        grade.createdDate = this.gradeDetails.createdDate;
        grade.createdBy = this.gradeDetails.createdBy;
        grade.modifiedBy = this.claims.UserId;
        grade.modifiedDate = new Date();

        request.requestInfo = grade;
        localStorage.setItem("gradeUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

        this.gradeService.UpdateGrade(request)
            .subscribe((response: IApiresponse<any>) => {
                if (response && response.errorInfo && response.errorInfo.length > 0) {
                    let lstErrInfo = response.errorInfo;
                    this.fnShowServerErrors(lstErrInfo);
                }
                else {
                    this.toastr.success(this.translate.instant("success"));
                    this.fnEmitSubmitEvent();
                }
                this.disableSaveButton = false;
            });
    }

    fnShowServerErrors(lstErrInfo: IErrorInfo[] = []) {

        if (lstErrInfo && lstErrInfo.length > 0) {
            let nameErrors = [];

            lstErrInfo.forEach(element => {
                switch (element.errorCode) {
                    case "GRD01":
                        nameErrors.push(this.translate.instant("name_exist"));
                        break;
                    default:
                        break;
                }
            });

            let nameField = GetField('gradeName', this.gradeFormFields);
            if (nameField) {
                nameField.templateOptions.customErrors = nameErrors;
            }
        }
    }

    fnEmitSubmitEvent() {
        let response = new AddGradePanelOutputModel(
            this.gradeFormModel.gradeStatus
        );
        this.submitEvent.emit(response);
    }

    fnShowGradeLoggingPanel(gradeId: number) {
        const model = new LoggingPanelModel(
            this.claims.OrgId.toString(),
            LogObjectActionTemplateEnum.Grade.toString(),
            gradeId.toString()
          );
          this.loggingPanelService.onShowLogPanel(model);
    }

    fnShowDeactivateConfirmationAlert() {
        this.deactivateConfirmationAlertModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [this.gradeDetails.isAnyEmployeeAssigned
                ? this.translate.instant("grade_deactivate_confirm_msg3")
                : this.translate.instant("grade_deactivate_confirm_msg2")],
            this.translate.instant("cancel"),
            this.translate.instant("label_confirm"),
            true,
            this.translate.instant("please_review_or_confirm")
            );
        this.showDeactivateConfirmationAlert = true;
    }

    fnDeactivateAlertPanelReceiver(returnValue) {
        if (returnValue) {
            this.fnBulkDeactiveGrade();
        }
        this.disableSaveButton = false;
        this.deactivateConfirmationAlertModel = null;
        this.showDeactivateConfirmationAlert = false;
    }

    fnBulkDeactiveGrade() {

        this.disableSaveButton = true;

        let request = new ApiRequest<IRequestGradeBulkDeactivate>("BulkDeactiveGrade",environment.applicationVersion, environment.requestId);

        const gradeIds = [this.inputModel.gradeId];

        request.requestInfo = new RequestGradeBulkDeactivate(
          gradeIds,
          this.claims.UserId,
          this.claims.FinanceManager
        );

        localStorage.setItem("gradeUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));

        this.gradeService.BulkDeactiveGrade(request)
            .subscribe((response: IApiresponse<any>) => {
                if (response.statusCode == 200) {
                    this.toastr.success(this.translate.instant("success"));
                    this.fnEmitSubmitEvent();
                }
                else {
                    this.toastr.success(this.translate.instant("error"));
                }
                this.disableSaveButton = false;
            });
      }
}
